import {
  EntityRatingCommentCount,
  Professional,
  ProfessionalFormationTypeEnum,
  Rating,
} from '@medprev-web-app/api-graphql-client';

import {
  SearchApiProfessional,
  SearchApiRating,
  SearchApiRatingComment,
} from '@/app/(main)/(pages)/_types/search-api-response.type';
import { RatingComment } from '@/types';

export function mapSearchApiRating(rating: SearchApiRating | null): Rating {
  return {
    fiveStars: {
      average: rating?.average ?? 0,
      count: rating?.ratingsCount ?? 0,
      tiers: {
        one: rating?.tiers?.one ?? 0,
        two: rating?.tiers?.two ?? 0,
        three: rating?.tiers?.three ?? 0,
        four: rating?.tiers?.four ?? 0,
        five: rating?.tiers?.five ?? 0,
      },
    },
  };
}

export function mapSearchApiCommentCount(rating: SearchApiRating | null): EntityRatingCommentCount {
  return { total: rating?.commentsCount ?? 0, comments: [] };
}

export function mapSearchApiRatingComment(comment: SearchApiRatingComment): RatingComment {
  return {
    id: comment.id,
    authorName: comment.authorName,
    comment: comment.comment,
    createdAt: comment.createdAt,
    ratingValue: comment.ratingValue,
    responseComment: comment.responseComment
      ? {
          id: comment.responseComment.id,
          comment: comment.responseComment.comment,
          createdAt: comment.responseComment.createdAt,
        }
      : undefined,
  };
}

export function mapSearchApiProfessional(
  professional: SearchApiProfessional,
  rating: SearchApiRating | null,
): Professional {
  return {
    id: professional.id,
    slug: professional.slug ?? '',
    name: professional.name,
    honorific: professional.honorific ?? null,
    avatar: professional.avatar ?? null,
    avatarLarge: professional.avatarLarge ?? null,
    description: professional.description ?? null,
    followUp: professional.followUp ?? null,
    minAge: professional.minAge ?? null,
    maxAge: professional.maxAge ?? null,
    languageAndAccessibility: professional.languageAndAccessibility ?? [],
    treatments: professional.treatments ?? [],
    licenses: (professional.licenses ?? []).map((license) => ({
      certificationBodyId: license.certificationBodyId,
      certificationBodyInitials: license.certificationBodyInitials,
      certificationBodyName: license.certificationBodyName,
      licenseState: license.licenseState,
      licenseRecord: license.licenseRecord,
    })),
    specialties: (professional.specialties ?? []).map((specialty) => ({
      id: specialty.id,
      name: specialty.name,
      isDisplayed: specialty.isDisplayed ?? false,
      specialistQualificationRecord: specialty.specialistQualificationRecord ?? null,
    })),
    professionalFormations: (professional.professionalFormations ?? []).map((formation) => ({
      type: formation.type as ProfessionalFormationTypeEnum,
      description: formation.description ?? null,
      location: formation.location ?? null,
      completionYear: formation.completionYear ? Number(formation.completionYear) : null,
    })),
    rating: mapSearchApiRating(rating),
  };
}
